import {
  CURRENT_COURSE_ID,
  CURRENT_LESSON_ID,
  USER_DETAILS,
} from "./constants";

export const setSessionDetails = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value));
};

export const setCurrentCourse = (value) => {
  window.localStorage.setItem(CURRENT_COURSE_ID, value);
};

export const setCurrentLesson = (value) => {
  window.localStorage.setItem(CURRENT_LESSON_ID, value);
};

export const getSessionDetails = (key) => {
  const value = window.localStorage.getItem(key);
  if (value) {
    return JSON.parse(value);
  } else {
    return null;
  }
};

export const getCurrentCourse = () => {
  const value = window.localStorage.getItem(CURRENT_COURSE_ID);
  if (value) {
    return value;
  } else {
    return null;
  }
};
export const getCurrentLesson = () => {
  const value = window.localStorage.getItem(CURRENT_LESSON_ID);
  if (value) {
    return value;
  } else {
    return null;
  }
};
export const removeSessionItem = (key) => {
  window.localStorage.removeItem(key);
};

export const clearSession = () => {
  const value = window.localStorage.removeItem(USER_DETAILS);

  if (value) {
    return JSON.parse(value);
  } else {
    return null;
  }
};
export const clearLessonId = () => {
  const value = window.localStorage.removeItem(CURRENT_LESSON_ID);

  if (value) {
    return JSON.parse(value);
  } else {
    return null;
  }
};

export const getAccessToken = () => {
  const value = window.localStorage.getItem(USER_DETAILS);
  if (value) {
    const json = JSON.parse(value);
    return json.access_token ? json.access_token : "";
  } else {
    return null;
  }
};

export const isValidUrl = (urlString) => {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};

export const isValidEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const isPasswordsValid = (password) => {
  //returns true if the email matches the regex for a valid email else returns false
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/.test(
    password
  );
};
export const QuestionType = {
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
  BOOLEAN_CHOICE: "BOOLEAN_CHOICE",
  MULTIPLE_ANSWER: "MULTIPLE_ANSWER",
  MATCHING: "MATCHING",
  ORDERING: "ORDERING",
  FILL_BLANKS: "FILL_BLANKS",
  ESSAY: "ESSAY",
};

export const getQuestionTypeString = (type) => {
  switch (type) {
    case QuestionType.MULTIPLE_CHOICE:
      return "Multiple Choice";
    case QuestionType.BOOLEAN_CHOICE:
      return "True / False";
    case QuestionType.MULTIPLE_ANSWER:
      return "Multiple Answer";
    case QuestionType.MATCHING:
      return "Matching";
    case QuestionType.ORDERING:
      return "Ordering";
    case QuestionType.FILL_BLANKS:
      return "Fill in the Blank";
    case QuestionType.ESSAY:
      return "Essay";
    default:
      return "";
  }
};

export const getQuestionOptionsPayload = (type) => {
  const options = [];
  switch (type) {
    case QuestionType.MULTIPLE_CHOICE:
      for (let i = 0; i < MULTIPLE_CHOICE_PAYLOAD.initialCount; i++) {
        options.push({ ...MULTIPLE_CHOICE_PAYLOAD.payload, order: i });
      }
      break;
    case QuestionType.BOOLEAN_CHOICE:
      for (let i = 0; i < BOOLEAN_CHOICE_PAYLOAD.initialCount; i++) {
        options.push({
          ...BOOLEAN_CHOICE_PAYLOAD.payload,
          order: i,
          answer: BOOLEAN_CHOICE_PAYLOAD.answerValue[i],
        });
      }
      break;
    case QuestionType.MULTIPLE_ANSWER:
      for (let i = 0; i < MULTIPLE_ANSWER_PAYLOAD.initialCount; i++) {
        options.push({
          ...MULTIPLE_ANSWER_PAYLOAD.payload,
          order: i,
        });
      }
      break;
    case QuestionType.MATCHING:
      for (let i = 0; i < MATCHING_PAYLOAD.initialCount; i++) {
        options.push({
          ...MATCHING_PAYLOAD.payload,
          order: i,
        });
      }
      break;
    case QuestionType.ORDERING:
      for (let i = 0; i < ORDERING_PAYLOAD.initialCount; i++) {
        options.push({
          ...ORDERING_PAYLOAD.payload,
          order: i,
          order_sequence: i + 1,
        });
      }
      break;
    case QuestionType.FILL_BLANKS:
      for (let i = 0; i < FILL_BLANKS_PAYLOAD.initialCount; i++) {
        options.push({
          ...FILL_BLANKS_PAYLOAD.payload,
          order: i,
          order_sequence: i + 1,
        });
      }
      break;
    case QuestionType.ESSAY:
      for (let i = 0; i < ESSAY_PAYLOAD.initialCount; i++) {
        options.push({
          ...ESSAY_PAYLOAD.payload,
          order: i,
        });
      }
      break;
    default:
      return {};
  }

  return options;
};

export const getQuestionSingleOption = (type, correctOrder = null) => {
  let options = undefined;
  switch (type) {
    case QuestionType.MULTIPLE_CHOICE:
      options = MULTIPLE_CHOICE_PAYLOAD.payload;
      options.order = correctOrder - 1;
      break;
    case QuestionType.BOOLEAN_CHOICE:
      options = BOOLEAN_CHOICE_PAYLOAD.payload;
      options.order = correctOrder - 1;
      break;
    case QuestionType.MULTIPLE_ANSWER:
      options = MULTIPLE_ANSWER_PAYLOAD.payload;
      options.order = correctOrder - 1;
      break;
    case QuestionType.MATCHING:
      options = MATCHING_PAYLOAD.payload;
      options.order = correctOrder - 1;
      break;
    case QuestionType.ORDERING:
      options = ORDERING_PAYLOAD.payload;
      options.order_sequence = correctOrder;
      options.order = correctOrder - 1;
      break;
    case QuestionType.FILL_BLANKS:
      options = FILL_BLANKS_PAYLOAD.payload;
      options.order = correctOrder - 1;
      break;
    default:
      return {};
  }

  return options;
};

export const MULTIPLE_CHOICE_PAYLOAD = {
  payload: {
    correct_answer: false,
    answer: "",
    answer_feedback: "",
    delete_answer: false,
    order: 0,
  },
  initialCount: 4,
};

export const BOOLEAN_CHOICE_PAYLOAD = {
  payload: {
    correct_answer: false,
    answer: "",
    answer_feedback: "",
    delete_answer: false,
    order: 0,
  },
  initialCount: 2,
  answerValue: ["true", "false"],
};

export const MULTIPLE_ANSWER_PAYLOAD = {
  payload: {
    correct_answer: false,
    answer: "",
    answer_feedback: "",
    delete_answer: false,
    order: 0,
  },
  initialCount: 4,
};

export const MATCHING_PAYLOAD = {
  payload: {
    answer: "",
    answer_feedback: "",
    delete_answer: false,
    order: 0,
    match: "",
  },
  initialCount: 4,
};

export const ORDERING_PAYLOAD = {
  payload: {
    answer: "",
    delete_answer: false,
    index: 0,
    order_sequence: "",
    match: "",
  },
  initialCount: 4,
  answerValue: [1, 2, 3, 4],
};

export const FILL_BLANKS_PAYLOAD = {
  payload: {
    answer: "",
    delete_answer: false,
    order: 0,
  },
  initialCount: 1,
};

export const ESSAY_PAYLOAD = {
  payload: {
    essay: "",
    essay_suggetion: "",
    order: 0,
  },
  initialCount: 1,
};

export const LESSON_CONTENT_TYPE = {
  FILE: "file",
  AUDIO_FILE: "audio_file",
  DISCUSSION_FORUM: "discussion_forum",
  DISCUSSION_POST: "discussion_box",
  DROPBOX: "dropbox",
  FILE_FROM_COURSE_RES: "file_from_course_resources",
  FILE_FROM_MY_REPO: "file_from_my_reporitory",
  FILE_FROM_GLOBAL_REPO: "file_from_global_reporitory",
  FOLDER_FROM_COURSE_REPO: "folder_from_course_repository",
  GOOGLE_MAP: "google_map",
  OTHER_EXT_EMB_CODE: "other_external_embeded_code",
  SCORM: "scorm",
  SURVEY: "survey",
  TEST: "test",
  TEXT_HTML_BLOCK: "text_html_block",
  // WIKI: "wiki",
  YOUTUBE_GOOGLE_VIDEO: "youtube_google_other_video",
};

export const sortArray = (data = [], key, order = 0) => {
  data = data.sort((a, b) => {
    if (order === 0 && a[key] < b[key]) {
      return -1;
    } else if (a[key] > b[key]) {
      return -1;
    }
    return 0;
  });
  return data;
};
